<template>
  <div class="m-container m-center-screen -with-bottombar">
    <BaseSpinner
      v-if="isLoading"
    />
    <div
      class="thank-you-stack"
      v-else
    >
      <PageHeader
        v-if="isSuccess"
        icon="checkCircle"
        iconSize="large"
        title="Návšteva bola odoslaná do evidencie"
        lead="Detail návštevy si môžete kedykoľvek pozrieť v zozname návštev."
        center
      />
      <PageHeader
        v-else
        icon="chat"
        iconSize="large"
        title="Nepodarilo sa uložiť návštevu"
        center
      />

      <BaseButton
        class="thank-you-button"
        @click="$router.push({ name: 'Dashboard' })"
      >
        Prejsť na hlavnú obrazovku
      </BaseButton>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import useMeStore from '@/stores/me';
import useVisitStore from '@/stores/visit';
import { useRouter } from 'vue-router';
import { saveVisit, getDashboardData } from '@/api';

import PageHeader from '@/components/PageHeader.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseSpinner from '@/components/BaseSpinner.vue';

const me = useMeStore();
const visit = useVisitStore();
const isLoading = ref(false);
const isSuccess = ref(false);

onMounted(async () => {
  isLoading.value = true;
  isSuccess.value = false;
  if (!visit.branch) {
    const router = useRouter();
    alert('Chyba: nie je nastavená pobočka');
    router.push({ name: 'Dashboard' });
    return;
  }

  try {
    const id = await saveVisit(visit.visitTransformed);
    if (id) {
      isSuccess.value = true;
      getDashboardData().then((data) => { me.dashboardData = data; });
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  } finally {
    visit.reset();
    isLoading.value = false;
  }
});
</script>

<style scoped>
.thank-you-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.thank-you-button {
  width: fit-content;
}
</style>
